
App.controller('ModalCtrl', function($scope, $rootScope, $location, $route){
	void 0;
	$rootScope.toggleSignup('show');
	$rootScope.modalServiceSignup = true;
	$rootScope.formData.domain_only = true;
	$rootScope.formData.registration_type = 'internal';
	$rootScope.formData.store =  true;
	$location.path('modal/price');
	$location.replace();
});

App.controller('LoginCtrl', function($scope, $rootScope, $location, $http){

	$http.defaults.useXDomain = true;
	var $mainError = $('#main-error');

	$scope.loginUser = function(){
		//after successfully logged in, make sure to populate POP.domainList
		$rootScope.ajax = true;
		
		$http({
			method: 'POST',
			url: POP.apiBaseUrl + '/user/login/',
			data: $.param({ email: $scope.formData.email, password: $scope.formData.password }),
			headers: {'Content-Type': 'application/x-www-form-urlencoded'}
		}).success(function(resp){
			$rootScope.ajax = false;
			
			if(resp.code === 200)
			{
				POP.clearCookies();
                $.cookie('pop_weasel', resp.data.token, { path:'/', domain:'.pop.co' });
                $.cookie('pop_domain', resp.data.email.split('@')[1], { path:'/', domain:'.pop.co' });

				$scope.successLogin = true;

				//redirect to update POP.currentUser
				$location.url('/modal/updateuser');
			} else {
				//show message
				$scope.errorMessage = resp.msg;
			}
		});
	}

	$scope.forgotPassword = function() {
		//after successfully logged in, make sure to populate POP.domainList
		$rootScope.ajax = true;
		
		$http({
			method: 'POST',
			url: POP.apiBaseUrl + '/user/forgot',
			headers: {'X-Requested-With': 'XMLHttpRequest'}
		}).success(function(resp){
			$rootScope.ajax = false;
			
			if(resp.code === 200)
			{
				POP.Message.response($mainError,resp, false, false);
			} else {
				//show message
				POP.Message.response($mainError,resp, false, false);
			}
		});
	}

	$scope.backtoDomain = function(){
		$location.path('/register');
		$location.replace();
	}

});

App.controller('PricingCtrl', function($scope, $rootScope, $location, $route){
	
	$scope.matrix = POP.currentServicePlans.html;
	$scope.service = POP.currentService.data.service;

	$scope.getPlan = function(plan) {
		$rootScope.selectedPlanModal = plan;
		//wait let's check if user is logged in
		if(typeof POP.currentUser == 'object')
		{
			$location.url('/modal/existing/domains');
		} else {
			//go to domain view
			$location.path('/register');
			$location.replace();
		}
	}

	if(Object.keys(POP.currentServicePlans.json.plans).length === 1)
	{
		$scope.getPlan(Object.keys(POP.currentServicePlans.json.plans)[0]);
	}

});

App.controller('ExistingDomainsCtrl', function($scope, $rootScope, $location, $route){
	
	$scope.service = POP.currentService.data.service.name;

	$scope.backtoPrice = function(){
		$location.url('/modal/price');
	}

	$scope.install = function(){
		//send user down service registration path
		$location.url('/modal/service');
	}

	$scope.domainList = POP.domainList;
	
	//if only 1 domain, then set it as current and direct user to service reg.
	if(POP.domainList.length == 1)
	{
		POP.currentDomain = POP.domainList[0];
		$location.url('/modal/service');
	}

	$scope.selectDomain = function(domain){
		POP.currentDomain = domain;
	}
});


App.controller('ServiceRegCtrl', function($scope, $rootScope, $location, $route){
	
});

App.controller('UpdateUserCtrl', function($scope,$rootScope,$location,$route) {
	void 0;
	$location.url('/modal/existing/domains');
});

App.controller('PercolatorCtrl', function($scope,$rootScope,$location, $route,$http,$timeout){
	$scope.progress = 60;

	$scope.poll = function() {
		
		//if params is undefined, this is coming from login and not from new user reg
		if(typeof POP.params != 'undefined')
		{
			$rootScope.ajax = true;
			$http({
				method: 'POST',
				data: { domain: POP.params.domain, domain_id: POP.params.domain_id },
				url: POP.apiBaseUrl + '/register/progress/',
				headers: {'X-Requested-With': 'XMLHttpRequest'}
			}).success(function(resp){

				if(resp.code == 200)
				{
					if(resp.data.login == true)
					{
						$rootScope.ajax = false;
				
						$.cookie('pop_weasel', resp.data.token, { path: '/', domain: '.pop.co' });
						$.cookie('pop_domain', POP.params.domain, { path: '/', domain: '.pop.co' });
				
						// remove other cookies to prevent re-hitting the percolator
						$.removeCookie('pop_domain_id', { path: '/', domain: '.pop.co' });
						$.removeCookie('pop_email', { path: '/', domain: '.pop.co' });
						$scope.progress = 100;

						$timeout(function(){
							$location.url('/modal/updateuser');
						}, 1000);
					} else {
						$timeout($scope.poll, 2000); 
					}
				}
			});
		} else {
			$timeout(function(){
				$location.url('/modal/updateuser');
			}, 1000);
		}
	}

	$scope.poll();	
});

App.factory(
	"transformRequestAsFormPost",
	function() {
		function transformRequest( data, getHeaders ) {

			var headers = getHeaders();

			headers[ "Content-type" ] = "application/x-www-form-urlencoded; charset=utf-8";

			return( serializeData( data ) );

		}
		return( transformRequest );

		function serializeData( data ) {
			if ( ! angular.isObject( data ) ) {
				return( ( data == null ) ? "" : data.toString() );
			}

			var buffer = [];
	
			for ( var name in data ) {
				if ( ! data.hasOwnProperty( name ) ) {
					continue;
				}
				var value = data[ name ];
				buffer.push(
					encodeURIComponent( name ) + "=" + encodeURIComponent( ( value == null ) ? "" : value )
				);
			}

			var source = buffer.join( "&" ).replace( /%20/g, "+" );
			return( source );
		}
	}
);
